export const data = {
	heading: 'Оплата членского взноса',

	qr: {
		description: 'Отсканируйте код в приложении банка, чтобы заполнить реквизиты автоматически.',
		sum: 'Сумма — 50 рублей.',
	},

	requisites: {
		title: 'Реквизиты',
		firstContent: [
			{
				description: 'Номер счёта получателя ',
				value: '4070 1810 5165 4000 0382',
			},
			{
				description: 'Наименование получателя',
				value: 'Кредитный потребительский кооператив «Фонд ипотечного кредитования»',
			},
			{
				description: 'ИНН/КПП',
				value: '6678102434 / 668501001',
			},
			{
				description: 'Название банка получателя',
				value: 'Уральский банк ПАО Сбербанка России',
			},
		],
		secondContent: [
			{
				description: 'БИК',
				value: '046577674',
			},
			{
				description: 'Город',
				value: 'Екатеринбург',
			},
			{
				description: 'Корр. счёт',
				value: '3010 1810 5000 0000 0674',
			},
			{
				description: 'Назначение платежа',
				value: 'Оплата обязательного паевого взноса в КПК «Фонд ипотечного кредитования»',
			},
		],
	},
}
